import {useNavigate, useLocation, Link} from "react-router-dom";
import {normalizeInput, normalizeDate, calculate_age, isvalid_mdy,normalizeUSDate} from './functions';
import React, {useState, useEffect} from "react";
import axios from "axios";
import  {get_golfer_memberships} from "../API/APICalls";

export default function ClubMembershipsDetail(){

    const navigate = useNavigate();
    const location = useLocation();


    const [otp, setOtp] = useState('');
    const onChange = (value: string) => setOtp(value);
    const [resendError, setResendError] = useState(false);

    const zipsearch = location.state.zipcode || '';
    const agadata = location.state.aga;
    const golferdata = location.state.inputs;
    const [inputs, setInputs] = useState({firstname: golferdata.firstname || '', lastname: golferdata.lastname, phone: golferdata.phone ||'', email: golferdata.email, dob: golferdata.dob || golferdata.date_of_birth || '' , sex: golferdata.sex|| golferdata.gender || '', address: golferdata.address || '', address2:  golferdata.address2 || '', city: golferdata.city || '', state:agadata[0].state, zip: agadata[0].zipcode ||'', contact: golferdata.contact_guid || golferdata.contact || '', handicapID: golferdata.handicapID || ''});


    const [zipcode, setZipcode] = useState(zipsearch);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [clubData, setClubData] = useState<any[]>([]);
    
   
    const fetchAPI = async () => {
        
        
       let results = [];

       const clubs = await get_golfer_memberships(inputs.handicapID)
       if (JSON.parse(clubs || '').club_affiliations.length > 0) {
    
        for (const record of JSON.parse(clubs || '').club_affiliations) {
            
             if (record.status == "Active")
                 {   
      
                    results.push(record);                    
                    
                    
                }
        }
        setClubData(results);
    
       }
       
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
       

    }


    useEffect(() => {
       
        //search memberships    
            fetchAPI();

    }, [inputs]);


    return (
        <div className="container page_container pb-2">
        <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-12 col-xxl-10 mx-auto">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 my-5 "><h1 className="fs-1 text-left">Your Active Memberships</h1></div>

          <form name="Verify Code" autoComplete="off" onSubmit={handleSubmit}> 
            
            
          {isLoading ?
            <div className="loaderWrapper">
                    <div className="loader"></div>
                    </div>
            
            :<>
            <div className="pb-0 mb-0"><h5>You have an active Handicap Index&reg; with the the following clubs:</h5></div>
            <div className="row pt-4">
                    <div className="col-5">
                    <h4 className="fs-4">AGA Name</h4>
                    </div>
                    <div className="col-4">
                    <h4 className="fs-4">Club Name</h4>
                    </div>
                    <div className="col-2">
                    <h4 className="fs-4">Expiry Date</h4>
                    </div>
                    
                </div>
            <div className="py-2">
            {!isLoading && clubData && clubData.map((results, index) => (
                <div className="row py-2" key={index}>
                    <div className="col-5">
                    {results.association_name}
                    </div>
                    <div className="col-4">
                    {results.club_name}
                    </div>
                    <div className="col-3">
                    {normalizeUSDate(results.inactive_date)}
                    </div>
                   
                </div>
            ))}
            </div>
            

            <hr className="col-12 mx-auto  small_hr"/>


            <div className="pt-4 col-6 mx-auto">
                <h4 className="text-center">Do you want to contine joining the {agadata[0].aga_club_name}?</h4>
            </div>


            <div className="row mt-4 col-12 col-sm-10 mx-auto">
                <div className="col-12 col-sm-6 order-1 pt-3">
                    <Link replace={true} to="/personal-lookup" state={{zipcode:zipsearch, aga:agadata, inputs:inputs}} className="w-100 btn btn-outline-secondary btn-lg rounded-pill px-5 " type="button">
                        NO THANKS
                    </Link>
                   
                </div>
                <div className="col-12 col-sm-6 order-sm-1 order-lg-1 pt-3">
                    <Link replace={true} to="/personal-info" state={{zipcode:zipsearch, aga:agadata, inputs:inputs}}  className="btn btn-primary w-100 btn-lg px-5 rounded-pill" type="submit">
                        YES
                    </Link>
                </div>
            </div>
            </>}
            </form>
        </div>
    </div>
    )
}